import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: false
})
export class StripHtmlPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        
        // Remove style blocks, class definitions, and HTML tags
        return value
            .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '') // Remove style blocks
            .replace(/<\/?[^>]+(>|$)/g, '') // Remove HTML tags
            .replace(/\.([a-zA-Z0-9_-]+)\s*\{[^}]*\}/g, '') // Remove class definitions
            .replace(/\s+/g, ' ') // Normalize whitespace
            .trim();
    }
}
